import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { t } from "i18next";

export type ColumnActionProps = {
  name: string;
  onDelete?: () => void;
  onEdit?: () => void;
};

const ColumnActions: React.FC<ColumnActionProps> = ({ name }) => {
  return (
    <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
      <a href="#" className="text-primary-600 hover:text-primary-900 mr-4">
        {t("general.edit")}
        <span className="sr-only">, {name}</span>
      </a>
      <a href="#" className="text-red-600 hover:text-red-900">
        <FontAwesomeIcon icon={faTrashCan} />
        <span className="sr-only">, {name}</span>
      </a>
    </td>
  );
};

export default ColumnActions;
